var map = {
	"./bonus_50000.png": 318,
	"./btn_gradient.png": 319,
	"./game_grid.png": 320,
	"./game_grid_blue.png": 321,
	"./hint_background.png": 322,
	"./letters/a.jpg": 131,
	"./letters/and.jpg": 132,
	"./letters/apos.jpg": 133,
	"./letters/b.jpg": 134,
	"./letters/c.jpg": 135,
	"./letters/d.jpg": 136,
	"./letters/dash.jpg": 137,
	"./letters/e.jpg": 138,
	"./letters/exclaim.jpg": 139,
	"./letters/f.jpg": 140,
	"./letters/g.jpg": 141,
	"./letters/h.jpg": 142,
	"./letters/i.jpg": 143,
	"./letters/j.jpg": 144,
	"./letters/k.jpg": 145,
	"./letters/l.jpg": 146,
	"./letters/m.jpg": 147,
	"./letters/n.jpg": 148,
	"./letters/o.jpg": 149,
	"./letters/p.jpg": 150,
	"./letters/period.jpg": 151,
	"./letters/q.jpg": 152,
	"./letters/r.jpg": 153,
	"./letters/s.jpg": 154,
	"./letters/selected.jpg": 155,
	"./letters/space.jpg": 156,
	"./letters/t.jpg": 157,
	"./letters/u.jpg": 158,
	"./letters/v.jpg": 159,
	"./letters/w.jpg": 160,
	"./letters/x.jpg": 161,
	"./letters/y.jpg": 162,
	"./letters/z.jpg": 163,
	"./lettersblue/a.jpg": 323,
	"./lettersblue/and.jpg": 324,
	"./lettersblue/apos.jpg": 325,
	"./lettersblue/b.jpg": 326,
	"./lettersblue/c.jpg": 327,
	"./lettersblue/d.jpg": 328,
	"./lettersblue/dash.jpg": 329,
	"./lettersblue/e.jpg": 330,
	"./lettersblue/exclaim.jpg": 331,
	"./lettersblue/f.jpg": 332,
	"./lettersblue/g.jpg": 333,
	"./lettersblue/h.jpg": 334,
	"./lettersblue/i.jpg": 335,
	"./lettersblue/j.jpg": 336,
	"./lettersblue/k.jpg": 337,
	"./lettersblue/l.jpg": 338,
	"./lettersblue/m.jpg": 339,
	"./lettersblue/n.jpg": 340,
	"./lettersblue/o.jpg": 341,
	"./lettersblue/p.jpg": 342,
	"./lettersblue/period.jpg": 343,
	"./lettersblue/q.jpg": 344,
	"./lettersblue/r.jpg": 345,
	"./lettersblue/s.jpg": 346,
	"./lettersblue/selected.jpg": 347,
	"./lettersblue/space.jpg": 348,
	"./lettersblue/t.jpg": 349,
	"./lettersblue/u.jpg": 350,
	"./lettersblue/v.jpg": 351,
	"./lettersblue/w.jpg": 352,
	"./lettersblue/x.jpg": 353,
	"./lettersblue/y.jpg": 354,
	"./lettersblue/z.jpg": 355,
	"./lettersdarkblue/a.jpg": 356,
	"./lettersdarkblue/and.jpg": 357,
	"./lettersdarkblue/apos.jpg": 358,
	"./lettersdarkblue/b.jpg": 359,
	"./lettersdarkblue/c.jpg": 360,
	"./lettersdarkblue/d.jpg": 361,
	"./lettersdarkblue/dash.jpg": 362,
	"./lettersdarkblue/e.jpg": 363,
	"./lettersdarkblue/exclaim.jpg": 364,
	"./lettersdarkblue/f.jpg": 365,
	"./lettersdarkblue/g.jpg": 366,
	"./lettersdarkblue/h.jpg": 367,
	"./lettersdarkblue/i.jpg": 368,
	"./lettersdarkblue/j.jpg": 369,
	"./lettersdarkblue/k.jpg": 370,
	"./lettersdarkblue/l.jpg": 371,
	"./lettersdarkblue/m.jpg": 372,
	"./lettersdarkblue/n.jpg": 373,
	"./lettersdarkblue/o.jpg": 374,
	"./lettersdarkblue/p.jpg": 375,
	"./lettersdarkblue/period.jpg": 376,
	"./lettersdarkblue/q.jpg": 377,
	"./lettersdarkblue/r.jpg": 378,
	"./lettersdarkblue/s.jpg": 379,
	"./lettersdarkblue/selected.jpg": 380,
	"./lettersdarkblue/space.jpg": 381,
	"./lettersdarkblue/t.jpg": 382,
	"./lettersdarkblue/u.jpg": 383,
	"./lettersdarkblue/v.jpg": 384,
	"./lettersdarkblue/w.jpg": 385,
	"./lettersdarkblue/x.jpg": 386,
	"./lettersdarkblue/y.jpg": 387,
	"./lettersdarkblue/z.jpg": 388,
	"./mute_icon_off.png": 389,
	"./mute_icon_on.png": 390,
	"./orientation_message.png": 391,
	"./wheel/5000.png": 164,
	"./wheel/500green.png": 165,
	"./wheel/500pink.png": 166,
	"./wheel/500violet.png": 167,
	"./wheel/550blue.png": 168,
	"./wheel/600blue.png": 169,
	"./wheel/600red.png": 170,
	"./wheel/650pink.png": 171,
	"./wheel/650violet.png": 172,
	"./wheel/700blue.png": 173,
	"./wheel/700red.png": 174,
	"./wheel/700yellow.png": 175,
	"./wheel/800orange.png": 176,
	"./wheel/800red.png": 177,
	"./wheel/900orange.png": 178,
	"./wheel/900pink.png": 179,
	"./wheel/900yellow.png": 180,
	"./wheel/bankrupt.png": 181,
	"./wheel/special.png": 182,
	"./wheel/spin_now_arrow.png": 183,
	"./wheel/spin_now_arrow_mobile.png": 184,
	"./wheel/wedge-LITEGAME-TEMPLATE.png": 185,
	"./wheel/wheel-LITEGAME-TEMPLATE(old).png": 186,
	"./wheel/wheel-LITEGAME-TEMPLATE.png": 187,
	"./wheel/wheel.png": 188,
	"./wof_logo.png": 392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 130;